import { call, put, select, takeLatest } from 'redux-saga/effects';
import { setAllCards, setCards } from './actions';
import { selectAllCards, selectCardsById, selectCardsLoaded } from './selectors';
import { ENSURE_CARDS, GET_ALL_CARDS } from './constants';
import { all } from '../services/card';

/**
 * Game events carry card references (id, place in the pile, attachments); what each card is comes from the
 * catalog, which is loaded once.
 */
export function* ensureCards() {
  if (!(yield select(selectCardsLoaded))) {
    const cards = yield call(all);
    yield put(setCards(cards));
  }

  return yield select(selectCardsById);
}

function* getAllCardsTask() {
  if (!(yield select(selectAllCards))) {
    yield put(setAllCards(yield call(all, { everything: true })));
  }
}

export default [
  function* getAllCardsWatcher() { yield takeLatest(GET_ALL_CARDS, getAllCardsTask); },
  function* ensureCardsWatcher() { yield takeLatest(ENSURE_CARDS, ensureCards); },
];
